import { render } from "./GlobalAdminSidebar.vue?vue&type=template&id=a9a773b8&scoped=true"
import script from "./GlobalAdminSidebar.vue?vue&type=script&lang=js"
export * from "./GlobalAdminSidebar.vue?vue&type=script&lang=js"

import "./GlobalAdminSidebar.vue?vue&type=style&index=0&id=a9a773b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a773b8"]])

export default __exports__